import { useAtomValue, useSetAtom } from 'jotai'
import { Role } from 'src/legacy_modules/entities/member/entity'
import {
  ItemType,
  SmallItem,
} from 'src/legacy_modules/entities/small-item/entity'

import { templateDetailAtom } from './atom'
import { update } from './request-update'
import { updateOrder } from './request-update-order'
import { useTemplateEntities } from '../../template-entities-context'

export const useSubmitTemplate = () => {
  const state = useAtomValue(templateDetailAtom)
  const setAtom = useSetAtom(templateDetailAtom)
  const { upsertTemplate } = useTemplateEntities()

  return async () => {
    const { originalTemplate, title, videoEnabled, mediumItems } = state

    const v2 = true
    let newMediumItem = mediumItems
    // v2で回答タイプがラベル以外であればinputRolesをDr/CRCに設定する(API側のバリデーションエラーになるため)
    if (v2) {
      newMediumItem = mediumItems.map(mi => {
        const newSmallItemMap: Record<string, SmallItem> = {}
        Object.values(mi.smallItemMap).forEach(si => {
          newSmallItemMap[si.uid] = {
            ...si,
            inputRoles:
              si.itemType !== ItemType.Label
                ? [Role.Dr, Role.CRC]
                : si.inputRoles,
          }
        })

        return {
          ...mi,
          smallItemMap: newSmallItemMap,
        }
      })
    }

    setAtom({ type: 'submitStarted' })
    try {
      const updated = await update({
        uid: originalTemplate!.uid,
        trialUid: originalTemplate!.trialUid,
        title,
        videoEnabled,
        mediumItems: v2 ? newMediumItem : mediumItems,
      })

      upsertTemplate(updated)
      setAtom({ type: 'submitDone' })
    } catch (error) {
      setAtom({ type: 'submitFailed' })
      throw error
    }
  }
}

export const useSubmitTemplateOrder = () => {
  const state = useAtomValue(templateDetailAtom)
  const setAtom = useSetAtom(templateDetailAtom)
  const { updateMediumItemOrder } = useTemplateEntities()

  return async () => {
    const { originalTemplate, mediumItems } = state

    setAtom({ type: 'submitStarted' })
    try {
      const response = await updateOrder({
        uid: originalTemplate!.uid,
        trialUid: originalTemplate!.trialUid,
        mediumItems,
      })

      updateMediumItemOrder(originalTemplate!.uid, response)
      setAtom({ type: 'submitDone' })
    } catch (error) {
      setAtom({ type: 'submitFailed' })
      throw error
    }
  }
}
